import {Box, Chip, Typography, Link} from "@mui/material";
import Button from "@mui/material/Button";
import GoogleIcon from "@mui/icons-material/Google.js";
import AppleIcon from "@mui/icons-material/Apple.js";
import {googleMap, appleMap} from "../shared/venue.ts";
import ReactMarkdown from "react-markdown";

const VenueMeta = (props) => {
    const {v} = props

    return <Box>
            <Box mt={2}>
                <Typography variant={"body2"}>{v.address}<br/>{v.city}, {v.state} {v.zip}</Typography>
            </Box>
            <Box mt={1}>
                 <Button startIcon={<GoogleIcon/>} href={googleMap(v)} variant={"outlined"} target="_blank"
                        size={"small"}>Maps</Button>&nbsp;
                 <Button startIcon={<AppleIcon/>} href={appleMap(v)} variant={"outlined"} target="_blank"
                        size={"small"}>Maps</Button>
            </Box>
            <Box mt={2}>
                <Typography variant={"overline"}>What To Expect</Typography>
            </Box>
            <Box>
                <ReactMarkdown components={{
                                a: Link,
                            }}>{v.whatToExpect}</ReactMarkdown>
            </Box>
            {v.daysToVisit && <Box mt={1}>
                Best Days: {v.daysToVisit}
            </Box>}
            <Box mt={1}>
                <VenueMetaCoverChip venue={v} />
                <VenueMetaAgeChip venue={v} />
            </Box>
    </Box>
}

export const VenueMetaCoverChip = props => <Chip label={props.venue.cover} size={"small"}/>
export const VenueMetaAgeChip = props => <Chip label={props.venue.age} size={"small"}/>
export const FreeChip = () => <Chip label={"Free"} size={"small"} color={"success"}/>

export default VenueMeta;